import { Form } from 'antd';
import FormItem from './formItem';
import './style/index';
const ZForm = Form;
const CustomForm = ZForm;
CustomForm.Item = FormItem;
export default CustomForm;